import React, { Component } from 'react';
import {
    Avatar,
    Row,
    Col,
    List,
    Divider,
    Icon,
    Spin, message
} from 'antd';

import AuthService from '../../Components/AuthService';
import UserProvider from '../../js/userProvider';
import DataService from '../../Components/Data';
import './DadosPerfil.css';

var AndroidFunction;
const Auth = new AuthService();

class DadosPerfil extends Component {

    constructor(props) {
        super(props);

        this.state = {
            buscando: true,
            dadosPerfil: [],
            anonimo: false
        }

        this.cdFilial = "";
        this.dataService = new DataService();
        this.dadosProvider = UserProvider.getInstance();
    }

    componentWillMount() {

        var filial = this.dadosProvider.getUiFilial();
        var usuario = this.dadosProvider.getDadosUsuario();
        var cdPessoa = "";
        var cdFilial = "";
        var anonimo = false;
        this.cdFilial = this.dadosProvider.getCdFilial();

        if (this.props != undefined && this.props.props != undefined) {
            this.props = this.props.props;

            var search = this.props.location.search;

            if (search.indexOf("&cdPessoa=") > -1 && search.indexOf("?cdFilial=") > -1) {

                anonimo = true;
                var pieces = search.split("&");
                cdFilial = pieces[0].replace("?cdFilial=", "");
                cdPessoa = pieces[1].replace("cdPessoa=", "");
                //this.dadosProvider.setCdFilial(pieces[0].replace("?cdFilial=", ""));
                //this.dadosProvider.setCdPessoa(pieces[1].replace("cdPessoa=", ""));
            }
        }



        //if(cdPessoa != "" && cdFilial != "" && cdPessoa != null && cdFilial != null){
        this.setState({ anonimo: anonimo })
        //}

        if (usuario == null && !this.state.anonimo) {
            Auth.logout();
            //this.props.history.push('/login');
        }
        
        if(cdFilial != "" && cdFilial != null){
            this.cdFilial = cdFilial;
        }

        var dados = {
            "uiPessoa": usuario != null ? usuario["UiPessoa"] : "",
            "uiFilial": (filial != "" && filial != null) ? filial : "",
            "cdPessoa": (cdPessoa != "" && cdPessoa != null) ? cdPessoa : "",
            "cdFilial": (cdFilial != "" && cdFilial != null) ? cdFilial : ""
        };

        this.dataService.GetDadoPerfil(dados, (retorno) => {

            this.setState({
                buscando: false,
                dadosPerfil: retorno
            });

        }, (erro, dados) => {
            message.error('Erro ao carregar dados do perfil: '+ JSON.stringify(dados));
            console.log(erro)
            this.setState({ buscando: false });
        });
    }

    modalFoto() {

        if (!this.state.anonimo) {
            if (AndroidFunction) {
                AndroidFunction.tirarFoto("motoPerfil", 3250);
            } else if (window.AndroidFunction) {
                window.AndroidFunction.tirarFoto("motoPerfil", 3250);
            }
        }

    }

    clearPhoto(url) {
        if (url != "" && url != undefined && url != null) {
            return url.replace(/&amp;/g, '&');
        } else {
            return "";
        }

    }

    render() {
        return (
            <div>

                {this.state.buscando ?
                    (<Row>
                        <Col className="imageRadio">
                            <div className="divSpin">
                                <Spin className="imageSpin" />
                            </div>
                        </Col>
                    </Row>) :
                    (<div>

                        {this.state.anonimo &&
                            <div className="marginTop20"></div>
                        }
                        <Row justify="center">
                            <Col className="text-center">
                                <Avatar
                                    onClick={() => this.modalFoto()}
                                    className="box-shadow-bt avatarPerfil"
                                    size="large"
                                    src={this.clearPhoto(this.state.dadosPerfil["DsUrlFoto"])} />                                    
                            </Col>
                        </Row>
                        <Row justify="center">
                            <Col className="text-center">
                                {this.state.dadosPerfil["StConectado"] == '0'? 
                                    (<strong className="text-red">Desconectado{this.state.dadosPerfil["DsTempoDesconectado"] != "N/D" && ". Última conexão: "+this.state.dadosPerfil["DsTempoDesconectado"]} </strong>): 
                                    <strong className="text-green">Conectado</strong> 
                                }                         
                            </Col>
                        </Row>
                        <br/>
                        <List
                            className="listPerfil"
                            bordered>
                            <List.Item>
                                <strong>Prefixo: <span> </span></strong> {this.state.dadosPerfil["NrPrefixo"]}
                            </List.Item>
                            <List.Item>
                                <strong>Nome: <span> </span></strong> {this.state.dadosPerfil["DsNome"]}
                            </List.Item>
                            {!this.state.anonimo &&
                                <div>
                                    <List.Item>
                                        <strong>Telefone:</strong> {this.state.dadosPerfil["NrCelular"]}
                                    </List.Item>
                                    <List.Item>
                                        <strong>Status da foto:</strong> {this.state.dadosPerfil["DsFotoStatus"]}
                                    </List.Item>
                                </div>
                            }
                        </List>

                        <List
                            className={["listPerfil", "marginTop24"]}
                            bordered>
                            <List.Item>
                                <strong>Informações do veículo:</strong> {this.state.dadosPerfil["DsMarca"]} - {this.state.dadosPerfil["DsModelo"]} - {this.state.dadosPerfil["NrAnoModelo"]} - {this.state.dadosPerfil["DsCor"]}
                            </List.Item>
                            <List.Item>
                                <strong>Preferências:</strong> {this.state.dadosPerfil["DsPreferencia"]}
                            </List.Item>
                        </List>


                            { (this.state.dadosPerfil["StMostraAvaliacao"] == true || this.state.dadosPerfil["StMostraAvaliacao"] == 1) &&
                                <div>
                                    <Divider className="divider">{this.state.dadosPerfil["DsAvaliacaoDesc"]}</Divider>

                                    <List
                                        className="listPerfil"
                                        bordered>
                                        <List.Item>
                                            <strong>Média das avaliações:</strong> <Icon type="star" /> {this.state.dadosPerfil["NrAvaliacao"]}
                                        </List.Item>
                                        <List.Item>
                                            <strong>Pontos a melhorar:</strong> {this.state.dadosPerfil["DsPontoMelhora"]}
                                        </List.Item>
                                    </List>
                                </div>
                            }
                    </div>)}
            </div>
        );
    }
}

export default DadosPerfil;


// WEBPACK FOOTER //
// ./src/Components/DadosPerfil/DadosPerfil.js